import type {
  AxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
} from 'axios';

export interface logResponseBody {
  type: string;
  url: string;
  headers: any;
  duration: number;
  dateTimeRequest: string;
  data?: any;
  config?: AxiosRequestConfig;
  status?: number;
}

export default function (
  response: AxiosResponse,
  timeLog: { start: Date; end: Date }
) {
  const size = import.meta.env.VITE_LOG_SIZE || '0';
  const sendResponse: {
    type?: string;
    url?: string;
    headers?: AxiosRequestHeaders;
    duration?: number;
    dateTimeRequest?: string;
    config?: {
      start?: string;
      url?: string;
    };
    status?: number;
    data?: string;
  } = {};

  // Добавление минимального набора информации
  sendResponse.type = 'response';
  sendResponse.url = response.config.url || '';
  sendResponse.headers = response.config?.headers;
  sendResponse.duration = +timeLog.end - +timeLog.start;
  sendResponse.dateTimeRequest = timeLog.start.toString();

  // Добавление статуса и конфига для базового набора информации
  if (size === '1' || size === '2') {
    sendResponse.config = response.config;
    sendResponse.status = response.status;
  }

  // Добавление тела ответа для максимального набора информации
  if (size === '2' && response.data) {
    const sendData = JSON.stringify(response.data);
    if (sendData.length < 20000) {
      sendResponse.data = sendData;
    } else {
      sendResponse.data = `{ saveError: 'large data size' }`;
    }
  }

  return sendResponse;
}
